import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DataForm from "./DataForm";
import { Box, Grid } from "@mui/material";
import MultiLineChart from "./MultiLineChart";
import ColumnChart from "./ColumnChart";
import DataTable from "./DataTable";
import ExportIcons from "./ExportIcons";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function Data() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    multiLineChartDataPrepared,
    columnChartDataPrepared,
    tableDataPrepared,
    clearAnalyzeData,
  } = state;

  return (
    <Box>
      <DataForm />

      {multiLineChartDataPrepared !== null &&
        columnChartDataPrepared !== null &&
        tableDataPrepared !== null &&
        clearAnalyzeData && (
          <>
            <CollapseSection title="Analyze Data">
              <ExportIcons />
              <Grid sx={{ mt: 3 }} columns={12} container spacing={2}>
                <Grid item md={7} lg={7}>
                  <MultiLineChart />
                </Grid>
                <Grid item md={5} lg={5}>
                  <ColumnChart />
                </Grid>
              </Grid>
            </CollapseSection>
            <DataTable />
          </>
        )}
    </Box>
  );
}
